import * as Yup from 'yup';

const ProjectMemberSchema = (projectDetails, totalAllotedHours, selected) =>
  Yup.object({
    userId: Yup.number().required('User is required'),
    userHours: Yup.number()
      .required('Hours is required')
      .max(
        projectDetails?.totalHrs - totalAllotedHours + (selected?.userHours ?? 0),
        `Available hours are '${(projectDetails?.totalHrs - totalAllotedHours + (selected?.userHours ?? 0)).toFixed(
          2
        )}'`
      )
      .min(
        selected?.totalTime ? parseFloat(selected?.totalTime) / 60 / 60 : 0,
        `Hours cannot be less than consumed hours.`
      ),
    projectRoleId: Yup.number().required('Please assign a role'),
    startDate: Yup.date().required('Start Date is required'),
  });

export const UpdateProjectMemberSchema = (projectDetails, totalAllotedHours, selected) =>
  Yup.object({
    userId: Yup.number().required('User is required'),
    userHours: Yup.number()
      .required('Hours is required')
      .max(
        projectDetails?.totalHrs - totalAllotedHours + (selected?.userHours ?? 0),
        `Available hours are '${(projectDetails?.totalHrs - totalAllotedHours + (selected?.userHours ?? 0)).toFixed(
          2
        )}'`
      )
      .min(
        selected?.totalTime ? parseFloat(selected?.totalTime) / 60 / 60 : 0,
        `Hours cannot be less than consumed hours.`
      ),
    projectRoleId: Yup.number().required('Please assign a role'),
    startDate: Yup.date().nullable(),
  });

export default ProjectMemberSchema;
